import React from "react";
import {
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { Tilt } from "react-tilt";
import { motion } from "framer-motion";
import { MoneyOff, Schedule, MonetizationOn, Group } from "@mui/icons-material";

// Benefits data (updated to avoid overlap)
const benefits = [
  {
    title: "No Cost to Join",
    description: "List your kitchen today for free and start earning immediately.",
    icon: <MoneyOff sx={{ fontSize: 40, color: "primary.main" }} />,
  },
  {
    title: "Flexible Scheduling",
    description: "Set your availability to fit your restaurant’s schedule.",
    icon: <Schedule sx={{ fontSize: 40, color: "primary.main" }} />,
  },
  {
    title: "Passive Income",
    description: "Earn money from your idle kitchen hours effortlessly.",
    icon: <MonetizationOn sx={{ fontSize: 40, color: "primary.main" }} />,
  },
];

const Benefits = () => {
  // Animation variants for card flip
  const cardVariants = {
    front: { rotateY: 0 },
    back: { rotateY: 180 },
  };

  return (
    <Box
      className="benefits-section"
      sx={{ py: 8, bgcolor: "background.paper" }}
    >
      <Typography variant="h2" color="text.primary" align="center" gutterBottom>
        Why List with AirKitchenz?
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {benefits.map((benefit, index) => (
          <Grid item xs={12} sm={6} md={3} key={benefit.title}>
            <Tilt options={{ max: 25, scale: 1.05 }}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.5 }}
                variants={cardVariants}
                className="benefit-card"
              >
                <Card sx={{ height: "100%", position: "relative", bgcolor: "#f9f9f9"}}>
                  <CardContent sx={{ textAlign: "center", p: 3 }}>
                    <motion.div
                      style={{ backfaceVisibility: "hidden" }}
                      animate={{ rotateY: 0 }}
                    >
                      {benefit.icon}
                      <Typography
                        variant="h6"
                        color="text.primary"
                        sx={{ mt: 2, mb: 1 }}
                      >
                        {benefit.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {benefit.description}
                      </Typography>
                    </motion.div>
                    <motion.div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backfaceVisibility: "hidden",
                        background: "linear-gradient(45deg, #e63946, #2c3e50)",
                        color: "#ffffff",
                      }}
                      animate={{ rotateY: 180 }}
                    >
                      <Button
                        variant="text"
                        color="inherit"
                        href="https://airkitchenz.com/profile/add-kitchen"
                      >
                        Learn More
                      </Button>
                    </motion.div>
                  </CardContent>
                </Card>
              </motion.div>
            </Tilt>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
